import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const steps = [
  { id: 1, label: 'Export Mode' },
  { id: 2, label: 'Configure' },
  { id: 3, label: 'Options' },
  { id: 4, label: 'Export' },
];

function StepIndicator({ currentStep, onStepClick }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      mb: 4,
      px: 2
    }}>
      {steps.map((step, index) => (
        <React.Fragment key={step.id}>
          {/* Step circle and label */}
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              cursor: step.id < currentStep ? 'pointer' : 'default',
              opacity: step.id <= currentStep ? 1 : 0.5,
              transition: 'all 0.3s ease',
              '&:hover': step.id < currentStep ? {
                transform: 'scale(1.05)',
              } : {}
            }}
            onClick={() => step.id < currentStep && onStepClick(step.id)}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: step.id < currentStep 
                  ? '#22c55e' 
                  : step.id === currentStep 
                    ? '#3b82f6' 
                    : 'rgba(255, 255, 255, 0.1)',
                border: step.id === currentStep 
                  ? '2px solid #60a5fa' 
                  : '2px solid transparent',
                transition: 'all 0.3s ease',
                boxShadow: step.id === currentStep 
                  ? '0 0 12px rgba(59, 130, 246, 0.4)' 
                  : 'none',
              }}
            >
              {step.id < currentStep ? (
                <CheckCircleIcon sx={{ fontSize: 20, color: 'white' }} />
              ) : (
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontWeight: 600, 
                    color: step.id <= currentStep ? 'white' : 'rgba(255, 255, 255, 0.5)'
                  }}
                >
                  {step.id}
                </Typography>
              )}
            </Box>
            {!isMobile && (
              <Typography 
                variant="caption" 
                sx={{ 
                  mt: 1, 
                  color: step.id <= currentStep ? 'text.primary' : 'text.secondary',
                  fontWeight: step.id === currentStep ? 600 : 400,
                  fontSize: '0.75rem',
                  whiteSpace: 'nowrap'
                }}
              >
                {step.label}
              </Typography>
            )}
          </Box>
          
          {/* Connector line */}
          {index < steps.length - 1 && (
            <Box
              sx={{
                flex: 1,
                height: 2,
                mx: { xs: 1, sm: 2 },
                maxWidth: { xs: 40, sm: 80 },
                backgroundColor: step.id < currentStep 
                  ? '#22c55e' 
                  : 'rgba(255, 255, 255, 0.1)',
                transition: 'background-color 0.3s ease',
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}

export default StepIndicator;

